import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=58c3dc94&scoped=true"
import script from "./InputFile.vue?vue&type=script&lang=js"
export * from "./InputFile.vue?vue&type=script&lang=js"
import style0 from "./InputFile.vue?vue&type=style&index=0&id=58c3dc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3dc94",
  null
  
)

export default component.exports